// Must stay in sync with $sidebar-width-vw in src/assets/styles/_sizing.scss
const SIDEBAR_WIDTH_VW = 0.055;

// Full CSS width expression for the sidebar — responsive but capped.
// Keep identical to $sidebar-width-vw so JS-driven positioning (e.g. the
// collapse toggle) lines up with the actual rendered edge.
const SIDEBAR_WIDTH_CSS = 'clamp(84px, 5.5vw, 104px)';

export { SIDEBAR_WIDTH_VW, SIDEBAR_WIDTH_CSS };
export default { SIDEBAR_WIDTH_VW, SIDEBAR_WIDTH_CSS };
